var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-group is-horizontal"},[_vm._t("fields")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }